import { InMemoryCache } from '@apollo/client';
import { LocalStorageWrapper, CachePersistor } from 'apollo3-cache-persist';
import { mergePagination } from '@social-garden/utils/pagination.ts';

export const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        messages: {
          keyArgs: ['creatorHasCampaignId'],
          merge: mergePagination,
        },
        myCampaigns: {
          keyArgs: ['input', ['brandIds', 'status']],
          merge: mergePagination,
        },
        myCampaignReports: {
          keyArgs: ['input', ['brandIds']],
          merge: mergePagination,
        },
        myCreatorHasCampaigns: {
          keyArgs: ['input', ['searchName', 'status']],
          merge: mergePagination,
        },
        myCreatorHasCampaignsOfCreator: {
          keyArgs: ['input', ['creatorId', 'status']],
          merge: mergePagination,
        },
        creatorsOfCampaign: {
          keyArgs: ['input', ['campaignId', 'status']],
          merge: mergePagination,
        },
        collaboratedBrands: {
          keyArgs: ['creatorId'],
          merge: mergePagination,
        },
      },
    },
    Download: {
      keyFields: ['hash'],
    },
  },
});

const APOLLO_CACHE_PERSIST_KEY = 'apolloCachePersist';

export const persistor = new CachePersistor({
  cache,
  storage: new LocalStorageWrapper(window.localStorage),
  key: APOLLO_CACHE_PERSIST_KEY,
  debug: import.meta.env.DEV,
});

export async function clearApolloCachePersist() {
  window.localStorage.removeItem(APOLLO_CACHE_PERSIST_KEY);
  await persistor.purge();
}
